import React, { useState } from 'react';
import { useBeforeInstallPrompt } from '../../../hooks/useBeforeInstallPrompt';
import Button from '../../UI/Button/Button';
import './PersonalAreaAddToHomeScreen.scss';

const PersonalAreaAddToHomeScreen = () => {
    const [prompt, promptToInstall] = useBeforeInstallPrompt();
    const [isVisible, setVisibleState] = useState(false);

    return (
        <>
            {prompt && (
                <div className="install-app" onClick={() => setVisibleState(true)}>
                    Install Emmezeta App
                </div>
            )}

            {isVisible && (
                <div className="install-popup">
                    <p className="install-popup__title">Would you like to install our app?</p>
                    <div className="install-popup__buttons">
                        <Button className="install-popup__button" trait="hover-submit" text="Yes" onClick={promptToInstall} />
                        <Button className="install-popup__button" trait="profile" text="No" onClick={() => setVisibleState(false)} />
                    </div>
                </div>
            )}
        </>
    );
};

export default PersonalAreaAddToHomeScreen;
